// Simple helpers for cookies
export const setCookie = (name, value, days = 7) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

export const getCookie = (name) => {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? match[2] : null;
}

export const slugify = (input, opts = {}) => {
    const {
        lower = true,
        separator = '-',
        strict = true,
        maxLength,
        replacements = { '&': 'and', '@': 'at', '€': 'euro' }
    } = opts;

    if (input == null) return '';

    const esc = s => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const sepEsc = esc(separator);

    // Characters that don't decompose via NFKD
    const charMap = {
        'ß': 'ss', 'ẞ': 'ss',
        'Æ': 'AE', 'æ': 'ae',
        'Ø': 'O', 'ø': 'o',
        'Ð': 'D', 'ð': 'd',
        'Þ': 'Th', 'þ': 'th',
        'Œ': 'OE', 'œ': 'oe'
    };

    let str = String(input);

    // 1) Custom replacements
    for (const [from, to] of Object.entries(replacements)) {
        str = str.replace(new RegExp(esc(from), 'g'), ` ${to} `);
    }

    // 2) Split camelCase/PascalCase
    str = str.replace(/([a-z\d])([A-Z])/g, '$1 $2');

    // 3) Normalize & strip diacritics
    str = str.normalize('NFKD').replace(/[\p{M}]/gu, ''); // remove combining marks

    // 4) Handle a few special letters
    str = str.replace(/[ßẞÆæØøÐðÞþŒœ]/g, m => charMap[m] || m);

    // 5) Drop zero-width/control chars
    str = str.replace(/[\u200B-\u200D\uFEFF\x00-\x1F\x7F]/g, '');

    // 6) Replace non-word chars with the separator
    const nonWord = strict ? /[^A-Za-z0-9]+/g : /[^\p{Letter}\p{Number}]+/gu;
    str = str.replace(nonWord, separator).trim();

    // 7) Collapse/trim separators
    str = str
        .replace(new RegExp(`${sepEsc}{2,}`, 'g'), separator)             // collapse
        .replace(new RegExp(`^${sepEsc}|${sepEsc}$`, 'g'), '');           // trim edges

    if (lower) str = str.toLowerCase();

    if (typeof maxLength === 'number' && maxLength > 0) {
        str = str.slice(0, maxLength).replace(new RegExp(`^${sepEsc}|${sepEsc}$`, 'g'), '');
    }

    return str;
}

export const getProductHandle = (url) => url ? url.split('products/')[1] : null